import * as React from "react";
import { observer } from "mobx-react";
import { observable, computed } from "mobx";
import { AccordionButton } from "../Buttons/AccordionButton";
import { ButtonGroup } from "../Buttons/ButtonGroup";
import { IContentGroupAccordionStatus } from "../States/AreaUiInfo";
import { Strings } from "../Stores/StringsStore";

export interface IContentGroupProps {
	caption: string;
	collapsed?: boolean;
	uiContext?: IContentGroupAccordionStatus;
	image?: JSX.Element;
	testId?: string;
	testName?: string;
	languageDependent?: boolean;
	languageCaption?: string;
	region?: string;
}

@observer
export class ContentGroup extends React.Component<IContentGroupProps, {}> {
	@observable collapsed = false;

	handleClick = (e: React.MouseEvent<any>) => {
		this.collapsed = !this.collapsed;
		if (this.props.uiContext) {
			this.props.uiContext.contentGroupAccordionStatus.set(
				this.props.caption,
				this.collapsed
			);
		}
		e.stopPropagation();
	};

	componentDidMount() {
		if (
			this.props.uiContext &&
			this.props.uiContext.contentGroupAccordionStatus.has(
				this.props.caption
			)
		) {
			this.collapsed =
				this.props.uiContext.contentGroupAccordionStatus.get(
					this.props.caption
				);
		} else {
			this.collapsed = this.props.collapsed;
		}
	}

	contentGroupChildren(buttonsOnly: boolean) {
		return React.Children.toArray(this.props.children).filter(
			(child: React.ReactElement<any>) => {
				return buttonsOnly
					? child.type === ButtonGroup
					: child.type !== ButtonGroup;
			}
		);
	}

	@computed get buttonTooltip() {
		return this.collapsed
			? Strings.general.expandButtonTooltip
			: Strings.general.collapseButtonTooltip;
	}

	render() {
		let className = this.collapsed
			? "contentgroup"
			: "contentgroup is--group-open";

		return (
			<div
				className={className}
				data-test-id={this.props.testId}
				data-test-name={this.props.testName}
			>
				<h2>
					<span
						className="contentgroup__label"
						onClick={this.handleClick}
					>
						{this.props.image}
						{this.props.caption}

						{this.props.languageDependent ? (
							this.props.region.toLocaleLowerCase() == "001" ? (
								<img
									className="lang-dependent"
									title={this.props.languageCaption}
									src={
										"../../images/flags/" +
										this.props.region +
										".png"
									}
								/>
							) : (
								<div
									title={this.props.languageCaption}
									className={
										"flag flag-" +
										this.props.region.toLowerCase()
									}
								/>
							)
						) : null}
					</span>
					<span className="contentgroup__additional">
						<div className="tinytool">
							{this.contentGroupChildren(true)}
						</div>
					</span>
					<span className="contentgroup__control">
						<div className="tinytool">
							<AccordionButton
								onClick={this.handleClick}
								title={this.buttonTooltip}
							/>
						</div>
					</span>
				</h2>
				<div className="contentgroup-content">
					{this.contentGroupChildren(false)}
				</div>
			</div>
		);
	}
}
